module.exports = __webpack_public_path__ + "img/goi_icon.791bac6b.png";